export default __webpack_public_path__ + "static/media/moon_color.758452fb.png";